import styled from 'styled-components';
import {GAME_BOX} from '../../../css-constants';


export const PlayRealButtonDefaultBox = styled.button<{isMobileOS: boolean;}>`
    background-image: url("${props => props.theme.images.spriteSheet.toString()}");
    background-position: -544px -409px;
    background-size: 1200px;
    background-repeat: no-repeat;
    position: absolute;
    cursor: pointer;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 6rem;
    height: 6rem;
    opacity: 0;
    transition: all 0.35s ease-in-out;

    @media ${({theme}) => theme.mediaQuery.hover} {
        .${GAME_BOX}:hover & {
            transform: translateY(0);
            opacity: 0.9;
        }
    }

    /** For the moment in mobiles we want this only for 888 skin so default is not displayed */
    display: ${({isMobileOS}) => isMobileOS ? "none" : "block"};

    .${GAME_BOX}:active & {
        transform: translateY(0);
        opacity: 0.9;
    }

    @media ${({theme}) => theme.mediaQuery.lowHeight}, ${({theme}) => theme.mediaQuery.xlExact} {
        background-position: -552px -408px;
    }

`;